class SlideIngredients extends HTMLElement {
  constructor() {
    super();

    this.slide = this;
    this.flkty = new Flickity(this.slide, {
      cellAlign: 'left',
      pageDots: true,
      adaptiveHeight: false,
      prevNextButtons: true,
      imagesLoaded: true,
      wrapAround: true,
      watchCSS: true
    });
  }
}

customElements.define("slide-ingredients", SlideIngredients);